import { getItemModelTitle } from '@/redux/modules/item/summary/itemSummary.selectors';
import { H1 } from '@liveauctioneers/hammer-ui-core/text';
import { useAppSelector } from '@/redux/hooks';

type Props = {
    className?: string;
    itemId: number;
};

export const PriceResultsItemTitle = ({ className, itemId }: Props) => {
    const title = useAppSelector((state) => getItemModelTitle(state, itemId));

    return <H1 className={className}>{title}</H1>;
};
